<script setup>
import { ref, onMounted, defineProps, defineModel, watch } from 'vue' 
import debounce from 'lodash.debounce'
import CompanyApi from '@/services/CompanyApi';

const crtProps = defineProps(['label', 'variant']);
const companies = ref([])
const selectedCompany = ref()
const model = defineModel({type: Object, default: { companyID: 0, name: ""} })
const loading = ref(false)

const searchCompanies = debounce(async (term) => {
    loading.value = true
    CompanyApi.search({ offset: 0, limit: 25, search: term }).then((response) => {
        if (response && response.data && Array.isArray(response.data.companies)) {
            companies.value = response.data.companies;   
        }
    }).finally(() => {
        loading.value = false
        if(term) {
            selectedCompany.value = term
        }

    })
})

onMounted(() => {
    if(model.value && model.value.companyID > 0 && model.value.name) {
        searchCompanies(model.value.name)
    }
    else {
        searchCompanies(undefined)
    }
})


const handleCompanyUpdate = (value) => {
    let crtCompany = companies.value.find(x => x.companyID == value);
    if(crtCompany) {
        model.value = crtCompany;
    }
    else {
        model.value = { companyID: 0, name: ""};
    }
}

watch(model, (value) => {
    if(value && value.companyID > 0 && value.name) {
        searchCompanies(value.name)
    }
    else {
        searchCompanies(undefined)
    }
})


</script>

<template>
        <div :class="crtProps.class">
            <v-autocomplete
                :variant="crtProps.variant ? crtProps.variant : 'solo'" 
                item-title="name"
                item-value="companyID" 
                density="compact" 
                :label="crtProps.label"
                :loading="loading"
                :items="companies"
                v-model="selectedCompany"
                @update:search="searchCompanies"
                @update:model-value="handleCompanyUpdate"
                autocomplete="one-time-code"
                hide-details
                :clearable="true">
            </v-autocomplete>
        </div>
</template>